import * as React from "react";
import { Widget, mk_widget, any } from "widgets-for-react";
import { CMSState } from "../../components/cms/blocks/types.gen";
import { ctaBlockClasses, quoteBlockClasses, expandBlockClasses } from "../../components/public_site/blocks/style.mod";
import { CtaBlock } from "../../components/cms/blocks/widgets/ctaBlock.gen";
import { dummyButton } from "../dummyContent";
import { QuoteBlock } from "../../components/public_site/blocks/custom_blocks/widgets/quoteBlock.mod";
import Plyr from 'react-plyr'
import { StyleguideChapter, StyleguideImgPlaceholder, StyleguidePart, StyleguideSection } from "./helpers"
import { pageHeader } from "./components/pageHeader";
import { ExpandBlock } from "../../components/cms/blocks/widgets/expandBlock.gen";

export const styleguideComponents: Widget<never> = mk_widget({
  run: _ => (
    <>
      {StyleguideChapter({ title: 'Expand block' })(
        StyleguideSection({ title: '', slug: 'components-expand' })(
          any()([
            StyleguidePart({ title: 'With title and intro of block', intro: '', isFullScreen: true })(
              ExpandBlock({
                block_index: 1,
                title: "Expandable block title",
                intro: "Nullam id dolor id nibh ultricies vehicula ut id elit. Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vestibulum id ligula porta felis euismod semper.",
                items: [
                  {
                    title: 'Closed item - Risus Lorem Etiam Ligula',
                    blocks: [],
                    open: false
                  },
                  {
                    title: 'Open item - Risus Lorem Etiam Ligula',
                    blocks: [{ blockKind: 'vidda/text', innerText: "Hello World" }],
                    open: true
                  }
                ],
                link: {
                  is_link_external: false,
                  kind: 'link',
                  title: 'Dapibus Fusce Quam',
                  target: '_blank',
                  url: '/'
                },
                navigation_title: "", 
                show_in_page_navigation: false
              },
                { style: expandBlockClasses }
              )({} as CMSState<{}, {}, never>)),
            StyleguidePart({ title: 'Without title and intro of block', intro: '', isFullScreen: true })(
              ExpandBlock({
                block_index: 2,
                items: [
                  {
                    title: 'Closed item - Risus Lorem Etiam Ligula',
                    blocks: [{ blockKind: 'vidda/text', innerText: "Hello World" }],
                    open: false
                  },
                  {
                    title: 'Open item - Risus Lorem Etiam Ligula',
                    blocks: [{ blockKind: 'vidda/text', innerText: "Hello World" }],
                    open: true
                  }
                ],
                link: {
                  is_link_external: false,
                  kind: 'link',
                  title: 'Dapibus Fusce Quam',
                  target: '_blank',
                  url: '/'
                },
                navigation_title: "", 
                show_in_page_navigation: false
              },
                { style: expandBlockClasses }
              )({} as CMSState<{}, {}, never>))
          ])
        )
      ).run(_)}
      {StyleguideChapter({ title: 'Site Header' })(
        StyleguideSection({ title: 'Secondary Navigation', slug: 'components-flyout' })(
          any()([
            StyleguidePart({ title: 'Desktop version', intro: 'The classname `flyout--open` should be applied to the `flyout`, when hovering the link in the menu, so that the secondary nav appeara', isFullScreen: true })(
              mk_widget({
                run: _ => (
                  <header className="header">
                    <div className="header__flyout flyout flyout--open">
                      <div className="flyout__inner container container--s grid--gutter">
                        <nav className="nav nav--submenu">
                          <ul className="nav__list list--chevron">
                            <li className="nav__item list__item">
                              <a className="nav__link list__link" href="#">
                                <svg
                                  className="nav__icon list__icon"
                                  width="8px"
                                  height="5px"
                                >
                                  <use xlinkHref="#icon--chevron" />
                                </svg>
                                <span>Text with anchor</span>
                              </a>
                            </li>
                            <li className="nav__item list__item">
                              <a className="nav__link list__link" href="#">
                                <svg
                                  className="nav__icon list__icon"
                                  width="8px"
                                  height="5px"
                                >
                                  <use xlinkHref="#icon--chevron" />
                                </svg>
                                <span>Purus Quam</span>
                              </a>
                            </li>
                            <li className="nav__item list__item">
                              <a className="nav__link list__link" href="#">
                                <svg
                                  className="nav__icon list__icon"
                                  width="8px"
                                  height="5px"
                                >
                                  <use xlinkHref="#icon--chevron" />
                                </svg>
                                <span>Risus Ultricies Parturient</span>
                              </a>
                            </li>
                            <li className="nav__item list__item">
                              <a className="nav__link list__link" href="#">
                                <svg
                                  className="nav__icon list__icon"
                                  width="8px"
                                  height="5px"
                                >
                                  <use xlinkHref="#icon--chevron" />
                                </svg>
                                <span>Pellentesque Ligula Bibendum</span>
                              </a>
                            </li>
                            <li className="nav__item list__item">
                              <a className="nav__link list__link" href="#">
                                <svg
                                  className="nav__icon list__icon"
                                  width="8px"
                                  height="5px"
                                >
                                  <use xlinkHref="#icon--chevron" />
                                </svg>
                                <span>Purus Quam</span>
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </header>
                )
              })
            )
          ])
        )
      ).run(_)}
      {StyleguideChapter({ title: 'Page Header' })(
        any()([
          StyleguideSection({ title: 'Homepage', slug: 'components-home-ph' })(
            StyleguidePart({ title: '', intro: '' })(
              mk_widget({
                run: _ => (
                  pageHeader({ title: 'Amet Cursus Vulputate Fermentum', pageType: 'home', hasImage: true })
                )
              })
            )
          ),
          StyleguideSection({ title: 'Generic page', slug: 'components-page-ph' })(
            any()([
              StyleguidePart({ title: 'Without Image', intro: '' })(
                mk_widget({
                  run: _ => (
                    pageHeader({ pageType: 'page', title: 'Amet Cursus Vulputate Fermentum', intro: 'Maecenas sed diam eget risus varius blandit sit amet non magna.', breadcrumbs: [{ title: 'Home', url: '/' }, { title: 'Dapibus Pellentesque', url: '/' }] })
                  )
                })
              ),
              StyleguidePart({ title: 'With Image', intro: '' })(
                mk_widget({
                  run: _ => (
                    pageHeader({ pageType: 'page', title: 'Amet Cursus Vulputate Fermentum', intro: 'Praesent commodo cursus magna, vel scelerisque nisl consectetur et. Vivamus sagittis lacus vel augue laoreet rutrum faucibus dolor auctor.', hasImage: true, breadcrumbs: [{ title: 'Home', url: '/' }, { title: 'Dapibus Pellentesque', url: '/' }] })
                  )
                })
              )
            ])
          ),
          StyleguideSection({ title: 'Update detail page', slug: 'components-update-ph' })(
            StyleguidePart({ title: '', intro: '' })(
              mk_widget({
                run: _ => (
                  pageHeader({ pageType: 'update', title: 'Amet Cursus Vulputate Fermentum', date: '04 januari 2021', intro: 'Donec sed odio dui. Maecenas sed diam eget risus varius blandit sit amet non magna.', hasImage: true, breadcrumbs: [{ title: 'Home', url: '/' }, { title: 'Dapibus Pellentesque', url: '/' }] })
                )
              })
            )
          )
        ])
      ).run(_)}

      {/* Custom block of older project */}
      <section
        // id="components"
        className="styleguide-chapter styleguide-chapter--components"
      >
        <header className="styleguide--styled styleguide-chapter__header">
          <h2 className="styleguide__title styleguide-chapter__title">
            Design Components
          </h2>
          <p className="styleguide-chapter__intro"></p>
        </header>

        <div className="styleguide-chapter__content">
          <section
            id="components-contentblocks"
            className="styleguide-section styleguide-section--components"
          >
            <header className="styleguide--styled styleguide-section__header">
              <h3 className="styleguide-section__title">Content blocks</h3>
              <p className="styleguide-section__intro"></p>
            </header>

            <div className="styleguide-section__content">
              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Video + text block</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description">This is a block that contains a video and a call to action </p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>

                    <div className="styleguide-example__section cf">

                      <section className="block block--video-cta">
                        <div className="block__inner">
                          <div className="block__wrap">
                            <div className="block__content">
                              <header className="block__header">
                                <h2 className="block__title title--ms">Bibendum Fermentum Consectetur Malesuada Sem</h2>
                                <p className="block__intro">Etiam porta sem malesuada magna mollis euismod. Vestibulum id ligula porta felis euismod semper.</p>
                              </header>
                              <footer className="block__footer">
                                <a href="/" className="block__link btn btn--secondary">Inceptos Pharetra</a>
                              </footer>
                            </div>
                            <figure className="block__visual">
                              <Plyr videoId="https://www.youtube.com/watch?v=q-yTIQWvD3A" />
                            </figure>
                          </div>
                        </div>
                      </section>

                    </div>
                  </section>
                </div>
              </section>

              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Quote block</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description"></p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>

                    <div className="styleguide-example__section cf">

                      {
                        QuoteBlock({
                          text: "Lorem ipsum sim dolor amet",
                          image: null,
                          author: "Margreet Janssen",
                          link_title: "Button tekst",
                          link_url: "#components",
                          navigation_title: "", 
                          show_in_page_navigation: false
                        }, { style: quoteBlockClasses })({} as CMSState<{}, {}, never>)(undefined).run(_ => { })
                      }

                    </div>
                  </section>
                </div>
              </section>

              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Latest updates</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description"></p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>

                    {/*
                    <div className="styleguide-example__section cf">

                      { 
                        LatestBlock({
                          title: "Laatste updates",
                          button: {
                            title: "Bekijk alle updates",
                            url: "#testURL"
                          },
                          hasBackground: false,
                          display: { kind: 'latest', updates:  }
                        }, {style: {}})({} as CMSState<{}, {}, never>)(undefined).run(_ => {}) 
                      } 

                    </div>
*/}

                    <div className="styleguide-example__section cf">

                      {/* { 
                        LatestBlock({
                          title: "Laatste updates",
                          button: {
                            title: "Bekijk alle updates",
                            url: "#testURL"
                          },
                          hasBackground: true,
                          display: { kind: 'selected', ids: [1, 2, 3] }
                        }, {style: {}})({} as CMSState<{}, {}, never>)(undefined).run(_ => {}) 
                      } */}

                    </div>
                  </section>
                </div>
              </section>

              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Form block</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description"></p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>

                    <div className="styleguide-example__section cf">

                      <section className="block block--form">
                        <div className="block__inner">

                          <header className="block--form__header">

                            <h2 className="block--form__title">Neem gerust contact op</h2>

                          </header>

                          <div className="block--form__content">
                            <div className="block--form__text text--styled">

                              <p>Bel ons op 010-242 1590 of stuur een e-mail naar <a href="#">hallo@hierkomteenlogo.nl</a></p>
                              <p><a href="#">Of bekijk onze veelgestelde vragen</a></p>

                              <h3>Postadres</h3>
                              <p>
                                U kunt ons uiteraard ook post sturen, gebruik hiervoor onderstaand postadres.<br />
                                <br />
                                Hierkomteenlogo B.V.<br />
                                Postbus 2936<br />
                                3000 CX Rotterdam
                              </p>

                              <h3>Formulier</h3>
                              <p>Of vul ons contactformulier in, zodat wij contact met u op kunnen nemen. We streven ernaar dit zo snel mogelijk te doen.</p>
                            </div>

                            <form className="block--form__form">

                              <div className="form__row">

                                <div className="form__item">

                                  <label htmlFor="name">
                                    <span className="form__label">Naam</span>
                                    <input type="text" name="text" className="form__input form__input--text" />
                                    <div className="form__alert form__alert--error">Dit veld is verplicht</div>
                                  </label>

                                </div>

                                <div className="form__item">

                                  <label htmlFor="email">
                                    <span className="form__label">E-mailadres</span>
                                    <input type="email" name="email" className="form__input form__input--email" value="test@testadres.com" />
                                    <div className="form__alert form__alert--success">Dit veld is goedgekeurd!</div>
                                  </label>

                                </div>

                              </div>

                              <div className="form__row">

                                <div className="form__item">

                                  <label htmlFor="phone">
                                    <span className="form__label">Telefoonnummer</span>
                                    <input type="number" name="phone" className="form__input form__input--number" />
                                  </label>

                                </div>

                                <div className="form__item">

                                  <label htmlFor="mortgage">
                                    <span className="form__label">Hypotheeknummer (optioneel)</span>
                                    <input type="number" name="mortgage" className="form__input form__input--number" />
                                  </label>

                                </div>

                              </div>

                              <div className="form__row">

                                <div className="form__item">

                                  <label htmlFor="message">
                                    <span className="form__label">Bericht</span>
                                    <textarea name="mortgage" className="form__input form__input--textarea" />
                                  </label>

                                </div>

                              </div>

                              <div className="form__row">

                                <div className="form__item">
                                  <input type="radio" className="radio" id="optionOne" name="radio" value="one" defaultChecked />
                                  <label htmlFor="optionOne" className="radio-label">Lorem</label>
                                </div>

                                <div className="form__item">
                                  <input type="radio" className="radio" id="optionTwo" name="radio" value="two" />
                                  <label htmlFor="optionTwo" className="radio-label">Ipsum sim</label>
                                </div>

                                <div className="form__item">
                                  <input type="radio" className="radio" id="optionThree" name="radio" value="three" />
                                  <label htmlFor="optionThree" className="radio-label">Dolor</label>
                                </div>

                                <div className="form__item">
                                  <input type="radio" className="radio" id="optionFour" name="radio" value="four" />
                                  <label htmlFor="optionFour" className="radio-label">Amet</label>
                                </div>

                              </div>

                              <div className="form__row">

                                <div className="form__item">
                                  <input type="submit" className="btn btn--primary" value="Verzenden" />
                                </div>

                              </div>

                            </form>

                          </div>
                        </div>

                      </section>

                    </div>
                  </section>
                </div>
              </section>

              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Text block</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description"></p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>

                    <div className="styleguide-example__section cf">
                      {/* { 
                        TextBlock({
                          key: 'text-block-styleguide',
                          title: 'Onze hypotheek is in beweging, net als u',
                          text: `Uw eerste kind? Of uw jongste kind vliegt alweer
                          uit. Minder werken? Of u zoekt het avontuur in
                          ondernemerschap. Trouwen? Of zonder elkaar verder.
                          In 30 jaar verandert uw leven regelmatig. En dan
                          is het wel zo prettig als uw hypotheek aansluit
                          bij uw nieuwe situatie. Dat begrijpen wij. Daarom
                          is onze hypotheek flexibel en kunt u zelf bepalen
                          waar u behoefte aan heeft. Of niet.`,
                          link: dummyButton('Link'),
                          primary_button: dummyButton('Primary Button')
                        }, {style: textBlockClasses})({} as CMSState<{}, {}, never>)(undefined).run(_ => {}) 
                      } */}
                    </div>
                  </section>
                </div>
              </section>

              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Table block</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description"></p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>

                    <div className="styleguide-example__section cf">

                      <div className="block block--table">
                        <div className="block__inner">

                          <div className="table-outer" tabIndex={0}>
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>Rentevaste periode</th>
                                  <th>t/m 60% marktwaarde</th>
                                  <th>t/m 80% marktwaarde</th>
                                  <th>t/m 90% marktwaarde</th>
                                  <th>t/m 100% marktwaarde</th>
                                  <th>t/m 60% marktwaarde</th>
                                  <th>t/m 80% marktwaarde</th>
                                  <th>t/m 90% marktwaarde</th>
                                  <th>t/m 100% marktwaarde</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>1-2 jaar</td>
                                  <td>1,56%</td>
                                  <td>1,60%</td>
                                  <td>1,96%</td>
                                  <td>2,06%</td>
                                  <td>1,56%</td>
                                  <td>1,60%</td>
                                  <td>1,96%</td>
                                  <td>2,06%</td>
                                </tr>
                                <tr>
                                  <td>3-5 jaar</td>
                                  <td>1,56%</td>
                                  <td>1,60%</td>
                                  <td>1,96%</td>
                                  <td>2,06%</td>
                                  <td>1,56%</td>
                                  <td>1,60%</td>
                                  <td>1,96%</td>
                                  <td>2,06%</td>
                                </tr>
                                <tr>
                                  <td>5-10 jaar</td>
                                  <td>1,56%</td>
                                  <td>1,60%</td>
                                  <td>1,96%</td>
                                  <td>2,06%</td>
                                  <td>1,56%</td>
                                  <td>1,60%</td>
                                  <td>1,96%</td>
                                  <td>2,06%</td>
                                </tr>
                                <tr>
                                  <td>5-10 jaar</td>
                                  <td>1,56%</td>
                                  <td>1,60%</td>
                                  <td>1,96%</td>
                                  <td>2,06%</td>
                                  <td>1,56%</td>
                                  <td>1,60%</td>
                                  <td>1,96%</td>
                                  <td>2,06%</td>
                                </tr>
                                <tr>
                                  <td>5-10 jaar</td>
                                  <td>1,56%</td>
                                  <td>1,60%</td>
                                  <td>1,96%</td>
                                  <td>2,06%</td>
                                  <td>1,56%</td>
                                  <td>1,60%</td>
                                  <td>1,96%</td>
                                  <td>2,06%</td>
                                </tr>
                              </tbody>
                              <tfoot>
                                <tr>
                                  <td colSpan={9}>Overbruggingsrente: 2,90%</td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>

                        </div>
                      </div>

                    </div>
                  </section>
                </div>
              </section>

              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Media block</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description"></p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>

                    <div className="styleguide-example__section cf">
                      <section className="block block--media container container--l grid--block">
                        <div className="block__inner">
                          <div className="block__content">
                            <figure className="block__visual">
                              <img src={StyleguideImgPlaceholder({ shape: { width: 1440, height: 720, radius: '0', bgColor: '#9CD1C2' }, text: { color: '#1e1e1e', font: 'Open Sans, sans-serif' } })} width="1440" height="720" alt="placeholder image" className="block__image image--rounded" />
                              <figcaption className="block__caption">Eventueel plek voor een caption</figcaption>
                            </figure>
                          </div>
                        </div>
                      </section>
                    </div>

                    <div className="styleguide-example__section cf">
                      <section className="block block--media container container--l grid--block">
                        <div className="block__inner">
                          <div className="block__content">
                            <figure className="block__visual">
                              <Plyr videoId="https://www.youtube.com/watch?v=q-yTIQWvD3A" />
                              <figcaption className="block__caption">Eventueel plek voor een caption</figcaption>
                            </figure>
                          </div>
                        </div>
                      </section>
                    </div>
                  </section>
                </div>
              </section>

              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Media block</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description"></p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>

                  </section>
                </div>
              </section>

              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Link lijst</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description"></p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>

                    <div className="styleguide-example__section cf">
                      <section className="block block--link-list">
                        <div className="block__inner">
                          <header className="block--link-list__header">
                            <h2 className="block--link-list__title">Titel</h2>
                          </header>
                          <div className="block--link-list__content">
                            <ul className="link-list">
                              <li className="link-list__item">
                                <a className="link-list__link" target="_self" href="#een">
                                  <span className="btn__text">Link lijst 1</span>
                                </a>
                              </li>
                              <li className="link-list__item">
                                <a className="link-list__link" target="_self" href="#twee">
                                  <span className="btn__text">Link lijst 2</span>
                                </a>
                              </li>
                              <li className="link-list__item">
                                <a className="link-list__link" target="_self" href="#drie">
                                  <span className="btn__text">Link lijst 3</span>
                                </a>
                              </li>
                              <li className="link-list__item">
                                <a className="link-list__link" target="_self" href="http://localhost:5000/">
                                  <span className="btn__text">Vierde item</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </section>
                    </div>
                  </section>
                </div>
              </section>

              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">CTA block</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description"></p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>

                    <div className="styleguide-example__section cf">
                      {CtaBlock(
                        {
                          title: "Titel lorem ipsum",
                          buttons: "primary_secondary",
                          intro: `Met een ofhankelijke hypotheekadviseur ontdekt u samen 
                          de beste hypotheek voor uw situatie`,
                          primary_button: dummyButton('Primary Button'),
                          secondary_button: dummyButton('Secondary Button'), 
                          navigation_title: "", 
                          show_in_page_navigation: false,
                        },
                        { style: ctaBlockClasses }
                      )({} as CMSState<{}, {}, never>).run(_ => { })}
                    </div>
                  </section>
                </div>
              </section>

              <section className="styleguide-part">
                <header className="styleguide--styled styleguide-part__header">
                  <h4 className="styleguide-part__title">Search Results</h4>
                </header>

                <div className="styleguide-part__content">
                  <div className="styleguide--styled styleguide-part__intro">
                    <p className="styleguide-part__description"></p>
                  </div>

                  <section className="styleguide-example">
                    <div className="styleguide--styled">
                      <h5 className="styleguide-example__title">Example(s)</h5>
                    </div>

                    <div className="styleguide-example__section cf">

                      <section className="search-results">
                        <div className="search-results__inner container">

                          <div className="search-results__content">

                            <form className="search-form">
                              <label className="search-form__label">
                                Uw zoekopdracht
                                <input
                                  className="search-form__input"
                                  placeholder="Lorem ipsum placeholder"
                                  type="text"
                                />
                                <button className="search-form__icon">
                                  <svg
                                    className="icon icon--arrow-right"
                                    width="26px"
                                    height="16px"
                                  >
                                    <use xlinkHref="#arrow-right" />
                                  </svg>
                                </button>
                              </label>
                            </form>

                            <ul className="results-list">

                              <li className="results-list__item">
                                <a href="#" className="results-list__result">

                                  <span className="results-list__label">
                                    Pagina
                                  </span>

                                  <h3 className="results-list__title">
                                    Hypotheekrenteaftrek
                                  </h3>

                                  <div className="results-list__description">
                                    Hoe zit het met de hypotheekrenteaftrek? Een vraag die je zeker niet mag vergeten..
                                  </div>

                                </a>
                              </li>

                              <li className="results-list__item">
                                <a href="#" className="results-list__result">

                                  <span className="results-list__label">
                                    Formulier
                                  </span>

                                  <h3 className="results-list__title">
                                    Hypotheekrenteaftrek
                                  </h3>

                                  <div className="results-list__description">
                                    Hoe zit het met de hypotheekrenteaftrek? Een vraag die je zeker niet mag vergeten..
                                  </div>

                                </a>
                              </li>

                              <li className="results-list__item">
                                <a href="#" className="results-list__result">

                                  <span className="results-list__label">
                                    Veelgestelde vraag
                                  </span>

                                  <h3 className="results-list__title">
                                    Hypotheekrenteaftrek
                                  </h3>

                                  <div className="results-list__description">
                                    Hoe zit het met de hypotheekrenteaftrek? Een vraag die je zeker niet mag vergeten..
                                  </div>

                                </a>
                              </li>

                            </ul>
                          </div>


                        </div>
                      </section>

                    </div>
                  </section>
                </div>
              </section>

            </div>
          </section>
        </div>
      </section>
    </>
  )
});



// WEBPACK FOOTER //
// ./Client/styleguide/components/components.tsx